import FileSelectedPanel from './FileSelectedPanelContainer';

export default FileSelectedPanel;